import * as Yup from 'yup';

import { TRANSACTION_DISPATCH_TYPES } from './common-types';

// Shared by kitchen and bar dispatch forms. RETURN transactions don't need
// batch allocations (the backend only requires them for DISPATCH/DISPOSAL);
// dispatch/disposal must select at least one batch, summing exactly to the
// line's quantity.
export function buildBatchAllocationsSchema(transactionType: TRANSACTION_DISPATCH_TYPES) {
  if (transactionType === TRANSACTION_DISPATCH_TYPES.RETURN) {
    return Yup.array().optional();
  }

  return Yup.array()
    .of(
      Yup.object().shape({
        batchId: Yup.string().required(),
        quantity: Yup.number().moreThan(0).required(),
      })
    )
    .min(1, 'Select at least one batch')
    .test(
      'sums-to-quantity',
      'Allocated quantity must equal line quantity',
      function sumsToQuantity(value) {
        const { quantity } = this.parent;
        const total = (value ?? []).reduce(
          (sum: number, allocation: { quantity: number }) => sum + (allocation.quantity || 0),
          0
        );
        return Math.abs(total - quantity) < 0.001;
      }
    );
}
